
import React, { Suspense } from "react";
import { useEffect, useState } from "react";
import Loading from "./public/components/Loading";
// import AdminApp from "./modules/admin/index";





export default () => {


  // const [mod,setMod] = useState<any>(null);
  
  // useEffect(()=>{

  //   // asyncMod().then(ret=>setMod(ret.default));

  // },[]);

  const mod = process.env.REACT_APP_MOD;

  if(mod == "admin"){

    const AdminComponent = React.lazy(() => import("./modules/admin/index"));
    return (
      <Suspense fallback={
        <div style={{ width: "100vw", height: "100vh", background: "var(--background)" }}>
  
         
            <Loading/>
          
  
        </div>
      } >
        <AdminComponent />
      </Suspense>
    )
  }

  if(mod == "agent"){
    const AgentComponent = React.lazy(() => import("./modules/agent/index"));
    return (
      <Suspense fallback={
        <div style={{ width: "100vw", height: "100vh", background: "var(--background)" }}>
            <Loading/>
        </div>
      } >
        <AgentComponent />
      </Suspense>
    )

  }

 
  return (
    <>
     
    </>
  )

};
